export default __webpack_public_path__ + "media/zurb/img/lab/pattern-4da520729da8d3b61636923126bdaeb0.png";